import { IntegrationsMarketplaceGridInstalledWebComponent } from './component/IntegrationsMarketplaceGridInstalledWebComponent';
import { WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_INSTALLED } from '../../webcomponents.constants';

export { IntegrationsMarketplaceGridInstalledWebComponent };

window.customElements.define(
  WEB_COMPONENT_INTEGRATIONS_MARKETPLACE_GRID_INSTALLED,
  IntegrationsMarketplaceGridInstalledWebComponent
);
